'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        scope: {
            items: '=myModel',
            singleFile: '=?mySingleFile',
            edit: '=?edit'
        },
        template: require('../../../view/file-uploader.html'),
        controller: ['$scope', 'Upload', 'ModalService', 'Notification',
            function ($scope, Upload, ModalService, Notification) {

                if ($scope.edit === null)
                    $scope.edit = true;

                if (!$scope.items)
                    $scope.items = [];

                // upload on file select or drop
                $scope.upload = function (file) {

                    if ($scope.singleFile)
                        $scope.items = [];

                    let localFile = {
                        name: file.name,
                        percent: 0.0
                    };

                    $scope.items.push(localFile);

                    Upload.upload({
                        url: 'api/attachments/upload',
                        data: {file: file, 'comment': $scope.username}
                    }).then(function (resp) {
                        angular.copy(resp.data._embedded, localFile);
                    }, function (resp) {
                        $scope.items.splice($scope.items.indexOf(localFile), 1);
                    }, function (evt) {
                        localFile.percent = parseInt(100.0 * evt.loaded / evt.total);
                    });
                };
                // for multiple files:
                $scope.uploadFiles = function (files) {
                    if (files && files.length) {
                        for (var i = 0; i < files.length; i++) {
                            $scope.upload(files[i]);
                        }
                    }
                };

                $scope.delete = function (file) {

                    ModalService.danger({
                        message: "Вложение будет удалено без возможности восстановления! Вы действительно желаете удалить данный файл?",
                        apply: "Да",
                        cancel: "Нет"
                    }).result.then(() => {
                            $scope.items.splice($scope.items.indexOf(file), 1);
                            Notification.success({
                                message: 'Вложение удалено!',
                            });
                        }
                    );
                };

                $scope.getSize = function (length) {
                    length = round(length);
                    if (length / 1000000000.0 > 1) {
                        return round(length / 1000000000.0) + ' Гб';
                    } else if (length / 1000000.0 > 1) {
                        return round(length / 1000000.0) + ' Мб';
                    } else if (length / 1000.0 > 1) {
                        return round(length / 1000.0) + ' Кб';
                    } else {
                        return round(length / 1.0) + ' байт';
                    }
                };

                function round(num) {
                    return Math.round(num * 100.0) / 100.0;
                }

            }]
    };
}